import React, { useEffect, useState } from 'react';
import { Button, Space } from 'antd';
import { MessageOutlined, PhoneOutlined, HeartFilled, HeartOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';


interface StickyHeaderProps {
  title: string;
  price: number;
  isNegotiable: boolean;
  isFavorited: boolean;
  startingChat: boolean;
  onChat: () => void;
  onCall: () => void;
  onFavorite: () => void;
  /** Pixel offset from top at which to show the header */
  threshold?: number;
}

const StickyHeader: React.FC<StickyHeaderProps> = ({
  title,
  price,
  isNegotiable,
  isFavorited,
  startingChat,
  onChat,
  onCall,
  onFavorite,
  threshold = 520,
}) => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > threshold);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [threshold]);

  return (
    <div className={`sticky-header ${visible ? 'sticky-header-visible' : ''}`}>
      <div className="sticky-header-inner">
        <div className="sticky-header-info">
          <span className="sticky-header-title">{title}</span>
          <span className="sticky-header-price">
            € {price.toLocaleString('de-DE')}
            {isNegotiable && <span className="sticky-negotiable">{t('sticky_header.negotiable')}</span>}
          </span>
        </div>
        <Space size={8}>
          <Button
            className="sticky-btn-fav"
            icon={isFavorited ? <HeartFilled style={{ color: 'var(--hp-primary)' }} /> : <HeartOutlined />}
            onClick={onFavorite}
            shape="circle"
          />
          <Button
            className="sticky-btn-outline"
            icon={<PhoneOutlined />}
            onClick={onCall}
          >
            {t('sticky_header.call')}
          </Button>
          <Button
            className="sticky-btn-primary"
            icon={<MessageOutlined />}
            loading={startingChat}
            onClick={onChat}
          >
            {t('sticky_header.chat')}
          </Button>
        </Space>
      </div>
    </div>
  );
};

export default StickyHeader;
